import { CBadge } from '@coreui/react';
import * as React from 'react';
import { rStat } from '../views/Stress';

export interface IStressLineModel {
    id: number;
    startTime: Date;
    endTime: Date;
    duration: number;
    durationSrv: number;
    status: number;
    statusSrv: number;
    message:string
}

interface IProps {
    line: IStressLineModel;
}

// Composant affichant une ligne de log du stresseur de web service
//
export class KStressLine extends React.Component<IProps> {
    public constructor(props: any) {
        super(props);
    }

    render() {
        let color = "light";
        switch (this.props.line.status) {
            case rStat.Wait: color = "secondary"; break;
            case rStat.Ended: color = "success"; break;
            case rStat.Pending: color = "warning"; break;
            case rStat.Cancelled: color = "dark"; break;
            case rStat.Error: color = "danger"; break;
            default: color = "light";
        }
        return (
            <tr key={this.props.line.id}>
                <td className="">{this.props.line.id}</td>
                <td className="">{this.props.line.startTime.toLocaleTimeString()}</td>
                <td className="">{this.props.line.endTime.toLocaleTimeString()}</td>
                <td className="">{this.props.line.duration}</td>
                <td className="">{this.props.line.durationSrv}</td>
                <td className=""><CBadge color={color}>&nbsp;</CBadge></td>
                <td className="">{this.props.line.statusSrv}</td>
               <td className="">{this.props.line.message}</td>
            </tr>
            )
    }
}